import { toast } from "react-toastify";
import { ImportReconCustomerMappingResponse } from "../../../Types/CustomerMapType";


export const handleImportFileUpload = async (
    file: File,
    importFn: (file: File) => Promise<ImportReconCustomerMappingResponse>,
    refetchFn: () => Promise<void>
): Promise<{ success: boolean; message: string; data?: ImportReconCustomerMappingResponse }> => {
    try {
        const response = await importFn(file);

        if (response.success_count > 0) {
            toast.success(`${response.success_count} record(s) imported successfully!`);
        }

        if (response.failed_count > 0) {
            response.errors.forEach(({ row, error }) => {
                const message =
                    error ??
                    Object.values(error).flat().join(", ");
                toast.error(`Row ${row}: ${message}`);
            });
        }

        await refetchFn();

        return {
            success: response.failed_count === 0,
            message:
                response.failed_count === 0
                    ? "File uploaded successfully!"
                    : `${response.success_count} imported, ${response.failed_count} failed.`,
            data: response,
        };
    } catch (error: any) {
        const msg =
            error?.response?.data?.error ||
            "Failed to upload file";
        toast.error(msg);
        return { success: false, message: msg };
    }
};